import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-folder-icon',
  templateUrl: './files-folder.component.html'
})
export class FilesFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
